import { defineMessages } from 'react-intl';

import generalMessages from 'src/messages';

const messages = defineMessages({
  fileName: {
    id: 'fileName',
    defaultMessage: 'File name',
  },
  edit: {
    id: 'edit',
    defaultMessage: 'Edit',
  },
});

export default { ...generalMessages, ...messages };
